import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { AppRoutes } from './app.routing';
import { CommonlayoutComponent } from './common-layout/common-layout.component';
import { HeaderComponent } from './common-layout/header/header.component';
import { FooterComponent } from './common-layout/footer/footer.component';
import { DataService } from './services/data.service';
import { UserService } from './services/user.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CommonService } from './services/common.service';
import { LoaderService } from './shared/loader/loader.service';
import { DataTablesModule } from 'angular-datatables';
import { LoginComponent } from './login/login.component';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/authenticate.service';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { AuthGuard } from './guards/auth.guard';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ToastrModule } from 'ngx-toastr';
import { NotificationService } from './services/notification.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataEntryService } from './services/data_entry.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MenuComponent } from './common-layout/menu/menu.component';
import { PublicationService } from './services/publication.service';
import { MasterService } from './services/masters.service';
import { WholesalerService } from './services/wholesaler.service';
import { PublisherService } from './services/publisher.service';
import { ExecutiveMemoService } from './services/executivememo.service';
import { SharedService } from './services/shared.service';
import { DatePipe } from '@angular/common';
import { GlobalSettingsService } from './services/global-settings.service';
import { ArchiveService } from './services/archive.service';
import { RestoreService } from './services/restore.service';
import { DataIntegrityService } from './services/data-integrity.service';
import { MissingService } from './services/missing.service';
import { BranchService } from './services/branch.service';
import { UploadErrorsService } from './services/upload-errors.service';
import { Reset_passwordComponent } from './ndm/reset_password/reset_password.component';
import { UploadVolumeService } from './services/upload-volume.service';
import { UploadService } from './services/upload.service';
import { Forgot_passwordComponent } from './forgot_password/forgot_password.component';
import { Change_passwordComponent } from './change_password/change_password.component';
import { ManualEditService } from './services/manula-edit.service';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { Activate_userComponent } from './activate_user/activate_user.component';
import { PWDAuthGuard } from './guards/pwd_auth.guard';
import { PBIService } from './services/pbi.service';
import { PBIResolver } from './resolver/pbi.resolver';
import { SharedModule } from './shared/shared.module';

const maskConfig: Partial<IConfig> = {
  validation: true,
};

@NgModule({ exports: [
        RouterModule,
        LoginComponent,
        Reset_passwordComponent,
        Forgot_passwordComponent,
        Change_passwordComponent,
        Activate_userComponent
    ],
    declarations: [
        AppComponent,
        TopBarComponent,
        CommonlayoutComponent,
        HeaderComponent,
        MenuComponent,
        FooterComponent,
        LoginComponent,
        Reset_passwordComponent,
        Forgot_passwordComponent,
        Change_passwordComponent,
        Activate_userComponent
    ],
    bootstrap: [
        AppComponent
    ], imports: [BrowserModule,
        // RouterModule.forRoot(AppRoutes, { useHash: true }),
        RouterModule.forRoot(AppRoutes),
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        AngularEditorModule,
        CommonModule,
        DataTablesModule,
        NgMultiSelectDropDownModule.forRoot(),
        ToastrModule.forRoot(),
        BrowserAnimationsModule,
        NgxMaskModule.forRoot(),
        NgbModule,
        PdfViewerModule,
        SharedModule], providers: [
        DatePipe,
        LoaderService,
        { provide: JWT_OPTIONS, useValue: JWT_OPTIONS }, JwtHelperService,
        AuthService,
        AuthGuard,
        PWDAuthGuard,
        DataService,
        UserService,
        CommonService,
        NotificationService,
        DataEntryService,
        PublicationService,
        MasterService,
        WholesalerService,
        PublisherService,
        ExecutiveMemoService,
        SharedService,
        GlobalSettingsService,
        ArchiveService,
        RestoreService,
        DataIntegrityService,
        MissingService,
        BranchService,
        UploadErrorsService,
        UploadVolumeService,
        UploadService,
        ManualEditService,
        PBIService,
        PBIResolver,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }